// removed by extract-text-webpack-plugin
module.exports = {"network-key":"styles-module__network-key___12XHV","key-icon":"styles-module__key-icon___3palo","key-label":"styles-module__key-label___tmn2H","seed-key":"styles-module__seed-key___crVGG","mode-toggle":"styles-module__mode-toggle___3cvJZ","toggle":"styles-module__toggle___1eFvD","toggle-on":"styles-module__toggle-on___2iCJR"};


//////////////////
// WEBPACK FOOTER
// ./src/vis-modules/force-graph/components/ModeToggleKey/styles.module.css
// module id = 729
// module chunks = 0